import type { ReactNode } from "react";

type LegalPageProps = {
  eyebrow?: string;
  title: string;
  intro: ReactNode;
  notice?: ReactNode;
  children: ReactNode;
};

export function LegalPage({
  eyebrow = "Rechtliches",
  title,
  intro,
  notice,
  children,
}: LegalPageProps) {
  return (
    <div className="bg-stone-50 pt-20 text-gray-950">
      <section className="border-b border-stone-200 bg-white">
        <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-gray-500">{eyebrow}</p>
          <h1 className="mt-4 text-4xl leading-tight lg:text-5xl">{title}</h1>
          <div className="mt-6 max-w-3xl text-base leading-relaxed text-gray-700">{intro}</div>
        </div>
      </section>

      <section className="py-12 lg:py-16">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          {notice ? (
            <div className="mb-6 rounded-3xl border border-amber-200 bg-amber-50 p-5 text-sm leading-relaxed text-amber-950">
              {notice}
            </div>
          ) : null}

          <div className="rounded-3xl border border-stone-200 bg-white p-6 shadow-sm sm:p-8 lg:p-10">
            <div className="space-y-10">{children}</div>
          </div>
        </div>
      </section>
    </div>
  );
}
